// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Josefin+Sans);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Encode+Sans+Expanded);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Encode Sans Expanded", sans-serif;
}

.logo-text {
  font: "Josefin Sans";

}

.center-align {
  text-align: center;
}

.black-bg {
  background: black;

}

.white-bg {
  background: white;

}

.primary-bg {
  background: #B05FFD;

}

.h1-hero {
  color: #fff;
  font-size: 48px;
  text-align: center;
  font-weight: bold;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }

}

.hero-text {
  color: #fff;
  font-size: 24px;
  text-align: center;

}

.img-wrap {
  height: 100%;
  max-width: 700px;
  margin: auto;

}

.fit-img {
  width: 100%;

}

.expand-row {
  width: 100%;
}

.white-text {
  color: white;
}

.black-text {
  color: black;
}

.gray-text {
  color: gray;
}

.pl {
  padding-left: 20px;
}

.pr {
  padding-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;;AAEtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;EAEjB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,WAAW;;AAEb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Josefin+Sans\");\n@import url(\"https://fonts.googleapis.com/css?family=Encode+Sans+Expanded\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Encode Sans Expanded\", sans-serif;\n}\n\n.logo-text {\n  font: \"Josefin Sans\";\n\n}\n\n.center-align {\n  text-align: center;\n}\n\n.black-bg {\n  background: black;\n\n}\n\n.white-bg {\n  background: white;\n\n}\n\n.primary-bg {\n  background: #B05FFD;\n\n}\n\n.h1-hero {\n  color: #fff;\n  font-size: 48px;\n  text-align: center;\n  font-weight: bold;\n\n  @media screen and (max-width: 768px) {\n    font-size: 40px;\n  }\n\n  @media screen and (max-width: 480px) {\n    font-size: 32px;\n  }\n\n}\n\n.hero-text {\n  color: #fff;\n  font-size: 24px;\n  text-align: center;\n\n}\n\n.img-wrap {\n  height: 100%;\n  max-width: 700px;\n  margin: auto;\n\n}\n\n.fit-img {\n  width: 100%;\n\n}\n\n.expand-row {\n  width: 100%;\n}\n\n.white-text {\n  color: white;\n}\n\n.black-text {\n  color: black;\n}\n\n.gray-text {\n  color: gray;\n}\n\n.pl {\n  padding-left: 20px;\n}\n\n.pr {\n  padding-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
